import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    if (authService.getAuthToken()) {
      if (state.url === '/') {
        router.navigate(['/dashboard']);
      }
    }

    return true;
  }

  router.navigate(['/signIn']);
  return false;
};

export const otpGuard: CanActivateFn = () => {
  const router = inject(Router);
  const nav = router.getCurrentNavigation();
  // eslint-disable-next-line dot-notation
  const emailFromNav = nav?.extras?.state?.['email'];

  if (emailFromNav) {
    return true;
  }

  return router.parseUrl('/signIn');
};

export default authGuard;
